/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const ClusterPairingEnum = {
    POST_CLUSTER_MASTER: '/cluster/join',
    POST_RESTORE_NODE: '/cluster/restore',
    GET_PROMOTE: (id: string): string => {
        return '/cluster/promote/' + id;
    },
    DELETE_CLUSTER: (id: string): string => {
        return '/cluster/' + id;
    },
    PUT_CLUSTER_RESYNC: '/cluster/resync',
    PUT_CLUSTER_APPLY: '/cluster/services-apply'
};
